import script from "./AdminTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminTable.vue?vue&type=style&index=0&id=0e375810&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e375810"]])

export default __exports__